import '../../styles/globals.css'
import { TextField, Button, Box, Grid, Typography } from '@mui/material'
import karmaStyles from '../../styles/KarmaPool.module.css'
import { Link, useLocation } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { useKarmaPoolContext } from '../../state/KarmaPoolContext';

function HomepageRegister() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [email, setEmail] = useState('');
    const [registrationState, setRegistrationState] = useState("NONE");
    const [registrationResultMessage, setRegistrationResultMessage] = useState("");

    const karmaContext = useKarmaPoolContext();
    const location = useLocation();

    const handleUsernameChange = (e) => setUsername(e.target.value);
    const handlePasswordChange = (e) => setPassword(e.target.value);
    const handleConfirmPasswordChange = (e) => setConfirmPassword(e.target.value);
    const handleEmailChange = (e) => setEmail(e.target.value);

    const handleSubmit = (event) => {
        event.preventDefault();

        if (password !== confirmPassword) {
            setRegistrationResultMessage("Passwords do not match.");
            setRegistrationState("ERROR");
            return;
        }

        const registrationCode = "KAR-MA1"; // hardcoded default code

        console.log("Registering with:", { username, email, registrationCode });

        fetch(karmaContext.getURLBaseAuthPath() + 'auth/register', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                username,
                email,
                registrationCode,
                password
            }),
        })
            .then((response) => {
                return response.json().then(data => ({ status: response.status, data }));
            })
            .then(({ status, data }) => {
                // Always display the message from the API
                if (data["message"]) {
                    setRegistrationResultMessage(data["message"]);
                }

                if (status === 201) {
                    console.log("Registration response data:", data);

                    // Registration successful
                    setRegistrationState("SUCCESS");

                    // Store the auth token from the registration response
                    if (data["token"]) {
                        window.localStorage.setItem("jwtAuthToken", "Bearer " + data["token"]);
                        window.location.href = "/karma/dashboard";
                    } else {
                        setRegistrationResultMessage("Registration succeeded but no token received.");
                        setRegistrationState("ERROR");
                    }
                } else {
                    // Registration failed
                    setRegistrationState("ERROR");
                }
            })
            .catch((err) => {
                console.log(err.message);
                setRegistrationResultMessage("Registration failed. Please try again.");
                setRegistrationState("ERROR");
            });
    };

    const renderStatusMessage = () => {
        if (registrationState === "NONE") return <Typography />;
        if (registrationState === "SUCCESS")
            return <Typography style={{ color: "green", marginTop: "1rem" }}>Registration successful!</Typography>;
        return <Typography style={{ color: "red", marginTop: "1rem" }}>{registrationResultMessage}</Typography>;
    };

    return (
        <>
            <Box className={karmaStyles.homepageBox} sx={{ paddingTop: "0.5rem" }}>
                <p className={karmaStyles.homepageDescription}><strong>Register</strong></p>

                <Box sx={{ marginTop: "1.5rem"}}>
                    <form noValidate autoComplete="off" onSubmit={handleSubmit}>
                        <Box sx={{ maxWidth: "420px", margin: "auto" }}>
                            <Grid container spacing={1} sx={{ marginLeft: "0%" }}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        sx={{ input: { color: 'white' }, label: { color: 'white' } }}
                                        id="username"
                                        label="Username"
                                        placeholder="username"
                                        variant="standard"
                                        onChange={handleUsernameChange}
                                        size="small"
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        sx={{ input: { color: 'white' }, label: { color: 'white' } }}
                                        id="email"
                                        label="Email"
                                        placeholder="email@example.com"
                                        variant="standard"
                                        onChange={handleEmailChange}
                                        size="small"
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        sx={{ input: { color: 'white' }, label: { color: 'white' } }}
                                        id="password"
                                        label="Password"
                                        type="password"
                                        placeholder="password"
                                        variant="standard"
                                        onChange={handlePasswordChange}
                                        size="small"
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        sx={{ input: { color: 'white' }, label: { color: 'white' } }}
                                        id="confirmPassword"
                                        label="Confirm Password"
                                        type="password"
                                        placeholder="password"
                                        variant="standard"
                                        onChange={handleConfirmPasswordChange}
                                        size="small"
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                        <Button
                            type="submit"
                            variant="contained"
                            color="info"
                            sx={{
                                backgroundColor: 'rgba(232, 232, 232, 0.5)',
                                marginTop: "1.0rem",
                                marginBottom: "0.75rem"
                            }}>
                            Register
                        </Button>
                    </form>
                </Box>
            </Box>

            {renderStatusMessage()}

            <Box>
                <p className={karmaStyles.homepageDescription}>
                    <Link to={"/karma"}>back</Link>
                </p>
            </Box>
        </>
    );
}

export default HomepageRegister;
